import {createSlice} from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'appSlice',
    initialState: {
        isRequesting: false,
        error: null,
        data: {
            showAppTour: true
        },
        done:false,
        metaData:{
            job:[],
        },
    },
    reducers: {
        reset_resources: () => {
            return {
                isRequesting: false,
                error: null,
                data: null,
                done:false,
                metaData:{
                    job:[],
                },
            };
        },
        get_resources: (state) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
            };
        },
        get_resources_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: {
                    ...state.data,
                    ...action.payload
                },
                done:true,
            };
        },
        get_resources_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                done:true,
            };
        },
        set_resources_meta_data: (state,action) =>{
            return {
                ...state,
                metaData:{
                    ...state.metaData,
                    ...action.payload,
                }
            };
        },
        toggle_show_app_tour: (state, action) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    showAppTour: action.payload.showAppTour
                }
            };
        }
    }
});

export const {reducer, actions} = slice;

export default reducer;